import Enum from "./Enum";

export default Enum.create( {
	UNTOGGLED: "UNTOGGLED",
	OPEN: "OPEN",
	CLOSED: "CLOSED",
} );
